import { AuthProvider } from '@contexts/AuthContext';
import { AppRouter }   from './routes/AppRouter';

export default function App() {
  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
}
